<div class="tab-content">
  <h2 class="admin-subsubheader">Logo-Karussell bearbeiten</h2>
  <p class="admin-text">An dieser Stelle können sowohl neue Logos hochgeladen als auch bereits hochgeladene Logos
    bearbeitet werden. Damit Logos im Karussell angezeigt werden, muss das Häkchen bei "Logo anzeigen?"
    gesetzt sein.
  </p>
</div>

<table mat-table [dataSource]="logos" matSort class="custom-elevation-z8">
  <!-- Logo Vorschau -->
  <ng-container matColumnDef="logo">
    <th mat-header-cell *matHeaderCellDef> Logo </th>
    <td class="image-column" mat-cell *matCellDef="let logo">
      @if(!logo.isPlaceholder) {
      @let url = logoCarouselFolder + logo.uuid + '/' + logoCarouselFileName;
      <img [src]="url" class="preview-img" />
      } @else {
      @let url = "/assets/placeholder-image.png";
      <img [src]="url" class="preview-img" />
      }
    </td>
  </ng-container>

  <!-- Im Karussell anzeigen -->
  <ng-container matColumnDef="showInCarousel">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Logo anzeigen? </th>
    <td mat-cell *matCellDef="let logo">
      @if(!logo.isPlaceholder) {
      <mat-slide-toggle [(ngModel)]="logo.showInCarousel" (change)="updateShowInCarousel()"></mat-slide-toggle>
      }
    </td>
  </ng-container>


  <!-- Löschen Button -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> Aktion </th>
    <td mat-cell *matCellDef="let logo">
      @if (logo.isPlaceholder) {

      <button mat-mini-fab (click)="uploadLogo(logo)">
        <mat-icon class="admin-success">upload</mat-icon>
      </button>

      } @else {

      <button mat-mini-fab (click)="deleteLogo(logo)">
        <mat-icon class="error">delete</mat-icon>
      </button>
      }
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

<div class="button-container" [ngClass]="{'hasChanges': hasChanges()}">
  <button (click)="cancel()" mat-raised-button>Abbrechen</button>
  <button (click)="confirm()" [disabled]="!hasChanges()" mat-flat-button>Speichern</button>
</div>